import React from 'react';
import './NewProjectHeader.css'

function NewProjectHeader() {
    return (
        <h1 className="newProjectHeader">New Project</h1>
    )
}

export default NewProjectHeader;